import { render, staticRenderFns } from "./club-team-and-groups.vue?vue&type=template&id=0459dcce&scoped=true&"
import script from "./club-team-and-groups.vue?vue&type=script&lang=ts&"
export * from "./club-team-and-groups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459dcce",
  null
  
)

export default component.exports